import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { publicMethods, baseUrl } from '../globals';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, tap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class FileUploadService {
  constructor(
    private http: HttpClient,
    private pubMethods: publicMethods,
    private auth: AuthenticationService
  ) {}

  private readonly CRM_MATCHER_ROUTE = '/matcher/crm';
  private readonly COMPANY_MATCHER_FILE_UPLOAD_ENDPOINT =
    '/company_matcher_file_upload/';

  private getCurrentPathname(): string {
    if (typeof window === 'undefined' || !window.location) {
      return '';
    }
    return window.location.pathname || '';
  }

  private getMatcherTypeFromRoute(): 'Regular' | 'CRM' {
    const pathname = this.getCurrentPathname();
    if (
      pathname === this.CRM_MATCHER_ROUTE ||
      pathname.startsWith(`${this.CRM_MATCHER_ROUTE}/`)
    ) {
      return 'CRM';
    }
    return 'Regular';
  }

  private shouldAttachMatcherType(endpoint: string): boolean {
    return endpoint?.trim() === this.COMPANY_MATCHER_FILE_UPLOAD_ENDPOINT;
  }

  uploadFile(files, data, endpoint): Observable<any> {
    let formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append(String(i), files[i]);
    }
    for (var key in data) {
      formData.append(key, data[key]);
    }
    if (this.shouldAttachMatcherType(endpoint)) {
      formData.append('matcherType', this.getMatcherTypeFromRoute());
    }
    return this.http
      .post(
        baseUrl + endpoint,
        formData,
        this.auth.helperGetVerifiedFilesDict()
      )
      .pipe(
        tap(_ => _),
        catchError(this.pubMethods.handleError('uploadFile', []))
      );
  }
}
